import { parseCupomOrLink } from "./offerPresentation";

export const IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp", "image/gif"];
export const IMAGE_MAX_BYTES = 8 * 1024 * 1024;

export function createOfferDraft(offer = null) {
  return {
    original: offer ? { ...offer } : null,
    name: offer?.name || "",
    price: offer?.offer_price == null ? "" : offer.offer_price,
    link: offer?.link || "",
    cupomOrLink: offer?.cupom || offer?.link_resgate || "",
    cupom: offer?.cupom || "",
    link_resgate: offer?.link_resgate || "",
    image: offer?.image_url || "",
    primaryKind: offer?.cupom || !offer?.link_resgate ? "cupom" : "link_resgate",
    expanded: false,
  };
}

export function draftCouponFields(draft) {
  if (draft.expanded) return { cupom: draft.cupom, link_resgate: draft.link_resgate };
  const parsed = parseCupomOrLink(draft.cupomOrLink);
  const key = draft.cupomOrLink.trim()
    ? (parsed.link_resgate ? "link_resgate" : "cupom")
    : draft.primaryKind;
  // The compact field edits one value; its complementary value stays in the draft.
  return { cupom: draft.cupom, link_resgate: draft.link_resgate, [key]: parsed[key] };
}

export function offerDraftPayload(draft) {
  const coupons = draftCouponFields(draft);
  const parsed = { cupom: coupons.cupom.trim().toUpperCase(), link_resgate: coupons.link_resgate.trim() };
  const price = draft.price === "" || draft.price == null ? null : Number(draft.price);
  const fields = {
    name: draft.name.trim(),
    link: draft.link.trim(),
    offer_price: price,
    ...parsed,
  };
  if (!draft.original) {
    return { ...fields, description: "", category: null, ...(draft.image ? { image: draft.image } : {}) };
  }
  // Updates are patches: omitted fields (including board/selo/destaque/category)
  // retain their server values, even if a poll changed them while editing.
  const originalDraft = createOfferDraft(draft.original);
  const originalFields = offerDraftPayload({ ...originalDraft, original: null });
  const payload = Object.fromEntries(Object.entries(fields).filter(([key, value]) => value !== originalFields[key]));
  if (draft.image !== (draft.original.image_url || "")) payload.image = draft.image;
  return payload;
}

export function draftHasChanges(draft) {
  return draft.original ? Object.keys(offerDraftPayload(draft)).length > 0 :
    !!(draft.name || draft.price !== "" || draft.link || draft.cupomOrLink || draft.cupom || draft.link_resgate || draft.image);
}

export function imageFileError(file) {
  if (!IMAGE_TYPES.includes(file.type)) return "Formato não aceito. Use PNG, JPEG, WEBP ou GIF.";
  if (file.size > IMAGE_MAX_BYTES) return "A imagem deve ter até 8 MB.";
  return "";
}
